<template lang="pug">
.input-group
  .form-control-static
    slot(name="feebody" v-bind:tax="tax" v-bind:showfee="showFee")
      span(v-if="showFee" :class="taxClass").tax-amount {{ tax.feeAmount | moneyFormat(tax.feeCurrency) | taxFilter }} {{ tax.feeCurrency }}
    slot(v-if="showFee" name="afterfee" v-bind:tax="tax" v-bind:showfee="showFee")
    a.link-hovered(v-show="!showFee && !evaluating" href="#" @click.stop.prevent="evalMe")
      span {{ linkText }}
    span(v-show="evaluating") {{ evaluatingText }}

</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import numbro from 'numbro';
import debounce from '@/polyfill/Debounce';
import { MoneyFormatFilter } from '@/models/filters/money';
import { MoneyAmount } from '@/models/finance/money';
import { PayoutEstimatedTaxInterface } from '@/components/forms/payout/payout-basics';
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";

@Component({
  name: 'payout-evaluate-fee-block',
  filters: {
    moneyFormat: MoneyFormatFilter,
    taxFilter(taxFormatted) {
      return taxFormatted.replace(/-/, '+')
    }
  },
})
export default class PayoutEvaluateFeeBlock extends Vue {
  @Prop({ required: true })
  model!: PayoutWebModel

  @Prop({ default: 'Рассчитать' })
  linkText!: string

  @Prop({ default: 'Рассчитывается...' })
  evaluatingText!: string

  tax: PayoutEstimatedTaxInterface | null = null;

  get taxClass() {
    return {
      'text-success': this.isNegativeCommission
    }
  }

  get isNegativeCommission() {
    return this.tax && (this.tax.feeAmount < 0)
  }

  get nAmount() {
    return numbro(this.model.values.amount).value();
  }

  get nCurrency() {
    return this.model.sourceAccount ? this.model.sourceAccount.currency : '';
  }

  get nAmountCurrency() {
    if ((this.nAmount <= 0) || (!this.nCurrency) || (this.nCurrency.length == 0)) return null;
    return `${this.nAmount} ${this.nCurrency}`;
  }

  @Watch('nAmountCurrency')
  onAmountCurrencyUpdate(val) {
    this.clean();
    // if (this.model.values.amount)
    //   this.evalMe();
    // else {
    //   this.tax = null;
    // }
  }

  clean() {
    this.dirty = false;
    this.tax = null;
  }

  dirty = false;

  evalMe() {
    if (!this.dirty)
      this.$emit('amount-dirty')
    this.dirty = true;
    this.tax = null;
    this.model.errors.clear();
    this.debouncedEvaluateFee(this.nAmount, this.nCurrency)
  }

  get showFee() {
    return !!this.tax;
  }

  get evaluating() {
    return this.model.evaluatingFeeStatus.isLoading || this.dirty;
  }

  debouncedEvaluateFee: any = null;

  created() {
    this.debouncedEvaluateFee = debounce(this.evaluateFee as any, 600);
  }

  evaluateFee(amount, currency) {
    if (!amount)
    {
      this.dirty = false;
      this.model.errors.set('amount', 'Amount is required.');
      return;
      // return Promise.reject('Invalid amount.');
    }
    this.model.values.amount = amount ? amount : '';
    this.model.values.currency = currency;
    this.model.errors.clear();
    return this.model.evaluateFee().then((resultFee) => {
      if ((amount != this.nAmount) || (currency != this.nCurrency)) return;
      this.tax = resultFee;
      this.dirty = false;
      this.$emit('tax', resultFee, new MoneyAmount(amount, currency));
      return this.tax;
    }).catch((err) => {
      this.dirty = false;
      this.$emit('taxfail', this.model.errors.errors, new MoneyAmount(amount, currency));
    });
  }
}
</script>

<style scoped lang="less">
.tax-amount {
  &.text-success {
    color: green;
    font-weight: bold;
  }
}
</style>

<i18n>
{
  "en": {
    "Рассчитать": "Calculate",
    "Рассчитывается...": "Calculating..."
  }
}
</i18n>
